import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const LeadingTeam = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
    margin-right: 3px;
`;
